import React, {useState, useEffect}  from "react";
import "./ProfileCard.css";
import { FaMapMarkerAlt } from "react-icons/fa";

const ProfileCard = ({userDetails, location}) => {
    const [state, setState] = useState({
        area: "",
        fullAddress: ""
    })
    useEffect(() => {
setState((preState) => ({
    ...preState,
    area: location.address_components[0].long_name,
    fullAddress: location.formatted_address,
}))
    }, [location])

  return (
    <div className="card-container">
      <div className="profile-pic">
        <img
          src={ userDetails?.staffImage ? userDetails?.staffImage : "https://randomuser.me/api/portraits/women/44.jpg"}
          alt="Albert Flores"
        />
      </div>
      <div className="card-content">
        <div className="name-row">
          <h2>{userDetails?.name}</h2>
          <span className="emp-id">{userDetails?.employeeId}</span>
        </div>
        {/* <p className="designation">UI/UX Designer</p> */}
        <hr />
        <div className="location-section">
          <div className="location-row">
            <FaMapMarkerAlt className="icon" />
            <h4 className="font-16">{state.area}</h4>
          </div>
          <p className="full-address">
           {state.fullAddress}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
